import React from 'react';

import { Table } from 'antd';
import { Redirect } from 'react-router-dom';
import { placeholder } from '../../placeholder/tableplaceholder';

import usePermissionItemsTable from '../../hooks/usePermissionItemsTable';

export default function Permissions({ authorized }) {
	const { data, columns } = usePermissionItemsTable();

	if (!authorized) {
		return <Redirect to="/" />;
	}

	return (
		<>
			<div className="permissions_table">
				<Table columns={columns} dataSource={data || placeholder} pagination={false} />
			</div>
		</>
	);
}
